import { render, staticRenderFns } from "./new_prospecto.vue?vue&type=template&id=368f22b6&scoped=true"
import script from "./new_prospecto.vue?vue&type=script&lang=js"
export * from "./new_prospecto.vue?vue&type=script&lang=js"
import style0 from "./new_prospecto.vue?vue&type=style&index=0&id=368f22b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f22b6",
  null
  
)

export default component.exports